import { graphql } from 'react-relay';

export const CandidateProfileImageEditMutation = graphql`
  mutation CandidateProfileImageEditMutation(
    $input: CandidateProfileImageEditInput!
  ) {
    CandidateProfileImageEdit(input: $input) {
      me {
        id
        profileImage {
          url(height: 50, width: 50)
        }
      }
      error
    }
  }
`;
